module.exports = __webpack_public_path__ + "static/media/Benefits-of-Using-a-Cold-Storage-Wallet-small.7328f4b7.jpg";